import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { first } from 'rxjs/operators';
import { Audit } from '@app/_models';
import { AuditService, AuthenticationService, AlertService } from '@app/_services';
import { Router } from '@angular/router';
import { SelectItem, LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-audit-list',
    templateUrl: './audit-list.component.html',
    styleUrls: ['./audit-list.component.css'],
    standalone: false
})
export class AuditListComponent implements OnInit
{

	@Input() auditUrl: string;
	@Input() source: string;
	@ViewChild('pt') table: Table;
	datasource: Audit[];
	audit: Audit;
	audits: Audit[] = [];
	columns: any[];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = false;
	userStatusOptions: SelectItem[];



	constructor(
		private authenticationService: AuthenticationService,
		private auditService: AuditService,
		private alertService: AlertService,
		private router: Router
	) { }


	ngOnInit()
	{
		try
		{
			this.columns = [
				{ field: 'id', header: 'Id' },
				{ field: 'date', header: 'Date' },
				{ field: 'author', header: 'Changed By' },
				{ field: 'property', header: 'Field' },
				{ field: 'left', header: 'Old' },
				{ field: 'right', header: 'New' },
				{ field: 'objectId', header: 'Object Id' },
			];

			// make sure we have a complete url.  won't work if adding new object since objectId is undefined.
			if (this.auditUrl.includes('undefined'))
			{
				return;
			}
			this.loading = true;
			this.auditService.findAll(this.auditUrl, this.source).pipe(first()).subscribe(
				data =>
				{
					// flatten the javers data
					for (let result of data.data.audits)
					{
						const flattened = <Audit>({
							id: result.commitMetadata.id.majorId,
							objectId: result.affectedLocalId,
							date: new Date(result.commitMetadata.commitDate),
							author: result.commitMetadata.author,
							property: result.propertyName,
							left: result.left,
							right: result.right
						});
						this.audits.push(flattened);
					}
					this.audits.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
					this.datasource = this.audits;
					setTimeout(() => {
						if (this.table) {
							this.table.reset(); // forces PrimeNG to recalculate paging
						}
					}, 0);
				},
				error =>
				{
					console.log('AUDIT LIST!: ' + JSON.stringify(error));
					this.alertService.error(error);
				},
				() => { this.loading = false; }
			);

		} catch (error)
		{
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	ngAfterViewInit() {
		console.log('Audit count:', this.audits.length); // Should log 58
	}

	onRowSelect(event)
	{
		try
		{
			// use this for adding query params
			// this.router.navigate(['user-edit'], { queryParams: { userId: event.data.userId } });
			this.router.navigate(['user-role-view', event.data.auditId]);
		} catch (error)
		{
			console.log('onRowSelect(' + event + ')' + error);
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
